export const DAYS_SHORT = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
export const DAYS_LETTER = ["L", "M", "M", "J", "V", "S", "D"];
export const DAYS_LONG = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export const pad = (n) => String(n).padStart(2, "0");
export const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fromISO = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};
export const weekday = (d) => (d.getDay() + 6) % 7;
export const todayISO = () => toISO(new Date());
export const thisMonth = () => todayISO().slice(0, 7);
export const monthName = (m) => MONTHS[Number(m.slice(5, 7)) - 1];

export function longDate(s) {
  const d = fromISO(s);
  return `${DAYS_LONG[weekday(d)]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function shortDay(s) {
  const d = fromISO(s);
  return { wd: DAYS_SHORT[weekday(d)].toUpperCase(), n: d.getDate() };
}

export function timeAgo(isoStr) {
  if (!isoStr) return "";
  const diff = (Date.now() - new Date(isoStr).getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  const d = new Date(isoStr);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export const stamp = (s) => {
  const d = new Date(s);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export function monthGrid(days) {
  const lead = weekday(fromISO(days[0]));
  return [...Array(lead).fill(null), ...days];
}
